/* ------------------------------------------------------------------------
   card-price - preco do card no padrao da pagina de produto (3 linhas):
     1) "de" pequeno e riscado   -> preco de venda (preco_promocao || preco)
     2) headline                 -> preco com desconto a vista + selo "PIX"
     3) parcelamento sem juros   -> "ou R$ X em Nx de R$ Y sem juros"

   Fonte dos numeros: os precos do PROPRIO produto (wsMain.globalData, ou
   window.__WS_SERVER_DATA__ quando a lista veio do SSR) - pix_discount e o
   parcelamento (max_installments / installment_interest_start /
   min_installment_value), com a mesma regra do card padrao
   (wsapi3-prod-template-rules): sem juros vai ate a parcela anterior a
   que comeca a cobrar juros.
   NAO usar o texto das condicoes da loja pro no de parcelas: "Parcele as
   compras em ate 12x" e o maximo COM juros - lido como "12x sem juros"
   o card anunciava 12x enquanto o produto mostrava 3x (23/09/2026). As
   condicoes so continuam como fallback do percentual do Pix.
   ------------------------------------------------------------------------ */
(function () {
  var CFG = { pixPct: 0, ready: false };
  var NBSP = String.fromCharCode(160);

  /* wsMain / ApiWS sao declarados com let/const no escopo global: existem
     como identificador, mas NAO como window.wsMain / window.ApiWS (que
     sempre deram undefined - o findProd nunca achava produto nenhum). */
  function getWsMain() { return typeof wsMain !== 'undefined' ? wsMain : null; }
  function getApiWS() { return typeof ApiWS !== 'undefined' ? ApiWS : null; }

  function fmt(v) {
    try {
      return Number(v).toLocaleString('pt-br', {
        style: 'currency', currency: 'BRL', minimumFractionDigits: 2
      });
    } catch (e) { return 'R$ 0,00'; }
  }

  function parsePrice(txt) {
    if (!txt) return 0;
    var s = String(txt).split(' ').join('').split(NBSP).join('');
    var m = s.match(/(\d[\d.]*,\d{2})/);
    if (!m) return 0;
    return Number(m[1].split('.').join('').replace(',', '.')) || 0;
  }

  function storeConds() {
    try {
      /* 1) SSR injeta window.__WS_SERVER_DATA__.storeInfo (sincrono, em toda pagina) */
      var sd = window.__WS_SERVER_DATA__ && window.__WS_SERVER_DATA__.storeInfo;
      var c = sd && (sd.conditions || sd.condicoes);
      if (Array.isArray(c) && c.length) return c;
      /* 2) infoLoja normalizada (so em paginas com ancora de condicao, ex. home) */
      var ws = getWsMain();
      var g = ws && ws.globalData && ws.globalData.infoLoja;
      c = g && (g.condicoes || g.conditions);
      return Array.isArray(c) ? c : [];
    } catch (e) { return []; }
  }

  /* infoLoja (com as condicoes) so e carregada nas paginas que tem ancora de
     condicao (home). Nas outras, dispara a mesma chamada padrao aqui. */
  function ensureInfoLoja(cb) {
    if (storeConds().length) { cb && cb(); return; }
    try {
      if (CFG._fetching) return;
      var api = getApiWS();
      if (api && api.Calls && typeof api.Calls.infosLojas === 'function') {
        CFG._fetching = true;
        Promise.resolve(api.Calls.infosLojas())
          .then(function () { CFG._fetching = false; cb && cb(); })
          .catch(function () { CFG._fetching = false; });
      }
    } catch (e) { CFG._fetching = false; }
  }

  function loadCfg() {
    var conds = storeConds();
    if (!conds.length) return false;
    conds.forEach(function (cond) {
      var t = ((cond.titulo || cond.title || '') + ' ' +
               (cond.subtitulo || cond.subtitle || '')).toLowerCase();
      if (t.indexOf('pix') !== -1 && !CFG.pixPct) {
        var mp = t.match(/(\d{1,2})\s*%/);
        if (mp) CFG.pixPct = Number(mp[1]);
      }
    });
    CFG.ready = true;
    return true;
  }

  /* Todos os produtos que o client-side conhece (listas montadas no navegador,
     ex. "Ultimos visitados"). Listas que vieram 100% do SSR caem em
     findServerPrices() abaixo. */
  function findProd(sku) {
    if (!sku) return null;
    sku = String(sku).trim();
    var ws = getWsMain();
    var g = (ws && ws.globalData) || {};
    var lists = [];
    /* aceita array puro ou o formato normalizado { produtos: [...] }
       (listLastProds / listHomeProds vem assim) */
    var push = function (l) {
      if (l && !Array.isArray(l) && Array.isArray(l.produtos)) l = l.produtos;
      if (Array.isArray(l)) lists = lists.concat(l);
    };
    if (g.infoProduto) lists.push(g.infoProduto);
    push(g.listHomeProds);
    push(g.listCategoryProds);
    push(g.listRelatedProds);
    push(g.listLastProds);
    push(g.listPreviousProds);
    if (g.listGroupProds && Array.isArray(g.listGroupProds.grupos)) {
      g.listGroupProds.grupos.forEach(function (gr) { push(gr && gr.produtos); });
    }
    return lists.find(function (p) {
      return p && String(p.codigo || p.cod || p.sku || '').trim() === sku;
    }) || null;
  }

  /* Produtos que vieram prontos do SSR (listas de relacionados, home etc.):
     window.__WS_SERVER_DATA__ traz o registro cru da API, com prices.* */
  var serverIndex = null;
  function findServerPrices(sku) {
    if (!sku) return null;
    if (!serverIndex) {
      var sd = window.__WS_SERVER_DATA__;
      if (!sd) return null;
      serverIndex = {};
      var add = function (rec) {
        if (rec && rec.sku != null && rec.prices) serverIndex[String(rec.sku).trim()] = rec.prices;
      };
      var walk = function (o, depth) {
        if (!o || typeof o !== 'object' || depth > 4) return;
        if (Array.isArray(o)) { o.forEach(function (x) { add(x); walk(x, depth + 1); }); return; }
        add(o);
        Object.keys(o).forEach(function (k) { if (k !== 'prices') walk(o[k], depth + 1); });
      };
      walk(sd, 0);
    }
    return serverIndex[String(sku).trim()] || null;
  }

  /* Precos normalizados do produto do card: globalData (formato wsjs) ou SSR (cru). */
  function pricesFor(sku) {
    var prod = findProd(sku);
    var p = prod && prod.precos;
    if (p) {
      return { max: Number(p.max_parcelas) || 0, start: Number(p.juros_inicia) || 0,
               fee: Number(p.juros) || 0, min: Number(p.valor_min_parcelas) || 0,
               pix: Number(p.desconto_avista) || 0 };
    }
    var r = findServerPrices(sku);
    if (r) {
      return { max: Number(r.max_installments) || 0, start: Number(r.installment_interest_start) || 0,
               fee: Number(r.installment_interest_percent) || 0, min: Number(r.min_installment_value) || 0,
               pix: Number(r.pix_discount) || 0 };
    }
    return null;
  }

  /* No de parcelas sem juros (0 = nao exibir a linha). Mesma regra do card
     padrao: com juros configurado, vai ate juros_inicia - 1; respeita o
     valor minimo da parcela. */
  function semJurosFor(pr, base) {
    if (!pr || pr.max < 2 || !base) return 0;
    var n = (pr.start > 0 && pr.fee > 0) ? Math.min(pr.max, pr.start - 1) : pr.max;
    while (n > 1 && pr.min > 0 && base / n < pr.min) n--;
    return n >= 2 ? n : 0;
  }

  function pixPctFor(pr) {
    if (pr && pr.pix > 0) return pr.pix;   /* desconto do proprio produto */
    return CFG.pixPct || 0;                /* fallback: condicao da loja */
  }

  function buildHTML(base, regular, pixPct, semJurosN) {
    if (!base) return '';
    var deLine = '';
    if (pixPct > 0) deLine = fmt(base);
    else if (regular > base) deLine = fmt(regular);

    var headline = pixPct > 0
      ? fmt(base - (base * pixPct / 100)) + ' <span class="cardpr-pix">PIX</span>'
      : fmt(base);

    var parc = '';
    if (semJurosN >= 2) {
      parc = 'ou ' + fmt(base) + ' em ' + semJurosN +
             'x de ' + fmt(base / semJurosN) + ' sem juros';
    }

    return (deLine ? '<span class="cardpr-de">' + deLine + '</span>' : '') +
           '<span class="cardpr-head">' + headline + '</span>' +
           (parc ? '<span class="cardpr-parc">' + parc + '</span>' : '');
  }

  function applyCard(card) {
    if (!card) return;
    var box0 = card.querySelector('.prod-showcase-price-container');
    if (!box0) return;
    if (card.matches('.unavailable, .unavaliable, .consult')) return;
    if (box0.querySelector('.prod-unavaliable-message, .prod-consult-message')) return;

    var sellEl = box0.querySelector('.prod-showcase-price-sell');
    var offEl  = box0.querySelector('.prod-showcase-price-off');
    var base = parsePrice(sellEl && sellEl.textContent);
    var regular = parsePrice(offEl && offEl.textContent);
    if (!base) return;

    var pr = pricesFor(card.getAttribute('ws-prod-sku') || card.getAttribute('data-prod-sku'));
    var pixPct = pixPctFor(pr);

    var html = buildHTML(base, regular, pixPct, semJurosFor(pr, base));
    if (!html) return;

    var box = null, kids = box0.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].className && kids[i].className.indexOf('cardpr-box') !== -1) { box = kids[i]; break; }
    }
    if (!box) {
      box = document.createElement('div');
      box.className = 'cardpr-box';
      box0.insertBefore(box, box0.firstChild);
    }
    if (box.getAttribute('data-h') === html) return;
    box.innerHTML = html;
    box.setAttribute('data-h', html);
    box0.classList.add('cardpr-on');
  }

  function run(root) {
    if (!CFG.ready) {
      loadCfg();
      if (!CFG.ready) ensureInfoLoja(function () { loadCfg(); run(); });
    }
    var scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('.prod-showcase-holder').forEach(applyCard);
  }

  function boot() {
    run();
    [300, 800, 1500, 2500, 4000].forEach(function (t) { setTimeout(run, t); });
    try {
      var mo = new MutationObserver(function (muts) {
        var hit = false;
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if ((n.matches && n.matches('.prod-showcase-holder')) ||
                (n.querySelector && n.querySelector('.prod-showcase-holder'))) hit = true;
          });
        });
        if (hit) window.requestAnimationFrame(function () { run(); });
      });
      if (document.body) mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', function () { run(); });
})();
